(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[362],{

/***/ 74585:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var lib = __webpack_require__(93212);
var icon = __webpack_require__(59213);

var GRAPH = 'M5.21939 16.2585V3H3V21H20.9999V18.7683H6.40788L10.6491 10.7268L16.4935 15.1379L20.8954 5.66713C21.1549 5.10882 20.9151 4.4447 20.3599 4.18377C19.8047 3.92284 19.1442 4.16391 18.8847 4.72221L15.64 11.7033L9.90492 7.37461L5.21939 16.2585Z';
var IconGraph = lib.variant('IconGraph', icon.Icon, {
    path: GRAPH,
});

exports.IconGraph = IconGraph;
//# sourceMappingURL=_icon-graph.js.map


/***/ }),

/***/ 1572:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var lib = __webpack_require__(93212);
var icon = __webpack_require__(59213);

var SHOPPING_CART = 'M17.4173 17.4087C17.9065 17.4087 18.3237 17.5889 18.6691 17.9495C19.0144 18.3101 19.187 18.7356 19.187 19.226C19.187 19.7163 19.0144 20.1346 18.6691 20.4808C18.3237 20.8269 17.9065 21 17.4173 21C16.9281 21 16.5036 20.8269 16.1439 20.4808C15.7842 20.1346 15.6043 19.7163 15.6043 19.226C15.6043 18.7356 15.7842 18.3101 16.1439 17.9495C16.5036 17.5889 16.9281 17.4087 17.4173 17.4087ZM3 3H5.95683L6.79856 4.77404H20.1151C20.3597 4.77404 20.5683 4.86418 20.741 5.04447C20.9137 5.22476 21 5.44471 21 5.70433C21 5.86298 20.9568 6 20.8705 6.11538L17.6763 11.9567C17.518 12.2308 17.2986 12.4543 17.018 12.6274C16.7374 12.8005 16.4317 12.887 16.1007 12.887H9.41007L8.61151 14.3582L8.56835 14.488C8.56835 14.5457 8.58993 14.5962 8.63309 14.6394C8.67626 14.6827 8.72662 14.7043 8.78417 14.7043H19.187V16.5216H8.39568C7.90647 16.5216 7.48921 16.3413 7.14388 15.9808C6.79856 15.6202 6.6259 15.1947 6.6259 14.7043C6.6259 14.4303 6.69784 14.149 6.84173 13.8606L8.05036 11.6106L4.81295 4.77404H3V3ZM8.39568 17.4087C8.88489 17.4087 9.30935 17.5889 9.66906 17.9495C10.0288 18.3101 10.2086 18.7356 10.2086 19.226C10.2086 19.7163 10.0288 20.1346 9.66906 20.4808C9.30935 20.8269 8.88489 21 8.39568 21C7.90647 21 7.48921 20.8269 7.14388 20.4808C6.79856 20.1346 6.6259 19.7163 6.6259 19.226C6.6259 18.7356 6.79856 18.3101 7.14388 17.9495C7.48921 17.5889 7.90647 17.4087 8.39568 17.4087Z';
var IconShoppingCart = lib.variant('IconShoppingCart', icon.Icon, {
    path: SHOPPING_CART,
});

exports.IconShoppingCart = IconShoppingCart;
//# sourceMappingURL=_icon-shoppingcart.js.map


/***/ }),

/***/ 97274:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var lib = __webpack_require__(93212);
var icon = __webpack_require__(59213);

var YOUTUBE = 'M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z';
var IconYoutube = lib.variant('IconYoutube', icon.Icon, {
    path: YOUTUBE,
});

exports.IconYoutube = IconYoutube;
//# sourceMappingURL=_icon-youtube.js.map


/***/ }),

/***/ 24492:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var index = __webpack_require__(74585);
__webpack_require__(93212);
__webpack_require__(80677);
__webpack_require__(59213);
__webpack_require__(93236);
__webpack_require__(19803);
__webpack_require__(10297);
__webpack_require__(24774);



exports.T = index.IconGraph;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 31615:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var index = __webpack_require__(1572);
__webpack_require__(93212);
__webpack_require__(80677);
__webpack_require__(59213);
__webpack_require__(93236);
__webpack_require__(19803);
__webpack_require__(10297);
__webpack_require__(24774);



exports.w = index.IconShoppingCart;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 36376:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var index = __webpack_require__(97274);
__webpack_require__(93212);
__webpack_require__(80677);
__webpack_require__(59213);
__webpack_require__(93236);
__webpack_require__(19803);
__webpack_require__(10297);
__webpack_require__(24774);



exports.z = index.IconYoutube;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 45115:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "vO": () => (/* binding */ deviceType)
/* harmony export */ });
/* unused harmony exports primaryInput, supportsPassiveEvents, supportsPointerEvents, supportsTouchEvents */
// so it doesn't throw if no window or matchMedia
var w = typeof window !== 'undefined' ? window : { screen: {}, navigator: {} };
var matchMedia = (w.matchMedia || (function () { return ({ matches: false }); })).bind(w);
// passive events test
// adapted from https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
var passiveOptionAccessed = false;
var options = {
    get passive() {
        return (passiveOptionAccessed = true);
    },
};
// have to set and remove a no-op listener instead of null
// (which was used previously), because Edge v15 throws an error
// when providing a null callback.
// https://github.com/rafgraph/detect-passive-events/pull/3
// eslint-disable-next-line @typescript-eslint/no-empty-function
var noop = function () { };
w.addEventListener && w.addEventListener('p', noop, options);
w.removeEventListener && w.removeEventListener('p', noop, false);
var supportsPassiveEvents = (/* unused pure expression or super */ null && (passiveOptionAccessed));
var supportsPointerEvents = 'PointerEvent' in w;
var onTouchStartInWindow = 'ontouchstart' in w;
var touchEventInWindow = 'TouchEvent' in w;
// onTouchStartInWindow is the old-old-legacy way to determine a touch device
// and many websites interpreted it to mean that the device is a touch only phone,
// so today browsers on a desktop/laptop computer with a touch screen (primary input mouse)
// have onTouchStartInWindow as false (to prevent from being confused with a
// touchOnly phone) even though they support the TouchEvents API, so need to check
// both onTouchStartInWindow and touchEventInWindow for TouchEvent support,
// however, some browsers (chromium) support the TouchEvents API even when running on
// a mouse only device (touchEventInWindow true, but onTouchStartInWindow false)
// so the touchEventInWindow check needs to include an coarse pointer media query
var supportsTouchEvents = onTouchStartInWindow ||
    (touchEventInWindow && matchMedia('(any-pointer: coarse)').matches);
var hasTouch = (w.navigator.maxTouchPoints || 0) > 0 || supportsTouchEvents;
// userAgent is used as a backup to correct for known device/browser bugs
// and when the browser doesn't support interaction media queries (pointer and hover)
// see https://caniuse.com/css-media-interaction
var userAgent = w.navigator.userAgent || '';
// iPads now support a mouse that can hover, however the media query interaction
// feature results always say iPads only have a coarse pointer that can't hover
// even when a mouse is connected (anyFine and anyHover are always false),
// this unfortunately indicates a touch only device but iPads should
// be classified as a hybrid device, so determine if it is an iPad
// to indicate it should be treated as a hybrid device with anyHover true
var isIPad = matchMedia('(pointer: coarse)').matches &&
    // both iPad and iPhone can "request desktop site", which sets the userAgent to Macintosh
    // so need to check both userAgents to determine if it is an iOS device
    // and screen size to separate iPad from iPhone
    /iPad|Macintosh/.test(userAgent) &&
    Math.min(w.screen.width || 0, w.screen.height || 0) >= 768;
var hasCoarsePrimaryPointer = (matchMedia('(pointer: coarse)').matches ||
    // if the pointer is not coarse and not fine then the browser doesn't support
    // interaction media queries (see https://caniuse.com/css-media-interaction)
    // so if it has onTouchStartInWindow assume it has a coarse primary pointer
    (!matchMedia('(pointer: fine)').matches && onTouchStartInWindow)) &&
    // bug in firefox (as of v81) on hybrid windows devices where the interaction media queries
    // always indicate a touch only device (only has a coarse pointer that can't hover)
    // so assume that the primary pointer is not coarse for firefox windows
    !/Windows.*Firefox/.test(userAgent);
var hasAnyHoverOrAnyFinePointer = matchMedia('(any-pointer: fine)').matches ||
    matchMedia('(any-hover: hover)').matches ||
    // iPads might have an input device that can hover, so assume it has anyHover
    isIPad ||
    // if no onTouchStartInWindow then the browser is indicating that it is not a touch only device
    // see above note for supportsTouchEvents
    !onTouchStartInWindow;
// a hybrid device is one that both hasTouch and
// any input can hover or has a fine pointer, or the primary pointer is not coarse
// if it's not a hybrid, then if it hasTouch it's touchOnly, otherwise it's mouseOnly
var deviceType = hasTouch && (hasAnyHoverOrAnyFinePointer || !hasCoarsePrimaryPointer)
    ? 'hybrid'
    : hasTouch
        ? 'touchOnly'
        : 'mouseOnly';
var primaryInput = deviceType === 'mouseOnly'
    ? 'mouse'
    : deviceType === 'touchOnly'
        ? 'touch'
        : // if the device is a hybrid, then if the primary pointer is coarse
            // assume the primaryInput is touch, otherwise assume it's mouse
            hasCoarsePrimaryPointer
                ? 'touch'
                : 'mouse';


//# sourceMappingURL=detect-it.esm.js.map


/***/ }),

/***/ 5899:
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;


/***/ }),

/***/ 13708:
/***/ ((module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(40507));

var _react = _interopRequireWildcard(__webpack_require__(93236));

var _swipeJsIso = _interopRequireDefault(__webpack_require__(54817));

var _lodash = _interopRequireDefault(__webpack_require__(5899));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ReactSwipe =
/*#__PURE__*/
function (_Component) {
  _inherits(ReactSwipe, _Component);

  function ReactSwipe() {
    _classCallCheck(this, ReactSwipe);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReactSwipe).apply(this, arguments));
  }

  _createClass(ReactSwipe, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.swipe = (0, _swipeJsIso.default)(this.containerEl, this.props.swipeOptions);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          childCount = _this$props.childCount,
          swipeOptions = _this$props.swipeOptions;
      var shouldUpdateSwipeInstance = prevProps.childCount !== childCount || !(0, _lodash.default)(prevProps.swipeOptions, swipeOptions);

      if (shouldUpdateSwipeInstance) {
        this.swipe.kill();
        this.swipe = (0, _swipeJsIso.default)(this.containerEl, this.props.swipeOptions);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.swipe.kill();
      this.swipe = void 0;
    }
  }, {
    key: "next",
    value: function next() {
      this.swipe.next();
    }
  }, {
    key: "prev",
    value: function prev() {
      this.swipe.prev();
    }
  }, {
    key: "slide",
    value: function slide() {
      var _this$swipe;

      (_this$swipe = this.swipe).slide.apply(_this$swipe, arguments);
    }
  }, {
    key: "getPos",
    value: function getPos() {
      return this.swipe.getPos();
    }
  }, {
    key: "getNumSlides",
    value: function getNumSlides() {
      return this.swipe.getNumSlides();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          id = _this$props2.id,
          className = _this$props2.className,
          style = _this$props2.style,
          children = _this$props2.children;
      return _react.default.createElement("div", {
        id: id,
        ref: function ref(el) {
          return _this.containerEl = el;
        },
        className: "react-swipe-container ".concat(className),
        style: style.container
      }, _react.default.createElement("div", {
        style: style.wrapper
      }, _react.default.Children.map(children, function (child) {
        if (!child) {
          return null;
        }

        var childStyle = child.props.style ? _objectSpread({}, style.child, child.props.style) : style.child;
        return _react.default.cloneElement(child, {
          style: childStyle
        });
      })));
    }
  }]);

  return ReactSwipe;
}(_react.Component);

_defineProperty(ReactSwipe, "propTypes", {
  swipeOptions: _propTypes.default.shape({
    startSlide: _propTypes.default.number,
    speed: _propTypes.default.number,
    auto: _propTypes.default.number,
    continuous: _propTypes.default.bool,
    disableScroll: _propTypes.default.bool,
    stopPropagation: _propTypes.default.bool,
    swiping: _propTypes.default.func,
    callback: _propTypes.default.func,
    transitionEnd: _propTypes.default.func
  }),
  style: _propTypes.default.shape({
    container: _propTypes.default.object,
    wrapper: _propTypes.default.object,
    child: _propTypes.default.object
  }),
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  childCount: _propTypes.default.number
});

_defineProperty(ReactSwipe, "defaultProps", {
  swipeOptions: {},
  style: {
    container: {
      overflow: 'hidden',
      visibility: 'hidden',
      position: 'relative'
    },
    wrapper: {
      overflow: 'hidden',
      position: 'relative'
    },
    child: {
      float: 'left',
      width: '100%',
      position: 'relative',
      transitionProperty: 'transform'
    }
  },
  className: '',
  childCount: 0
});

var _default = ReactSwipe;
exports["default"] = _default;
module.exports = exports["default"];


/***/ }),

/***/ 11104:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BrandPageLoader": () => (/* binding */ BrandPageLoader),
  "default": () => (/* binding */ components)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_fxintbam4sfi3slcde3hiy3qty/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(3732);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/breadcrumbs/index.js
var breadcrumbs = __webpack_require__(58079);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(88557);
;// CONCATENATED MODULE: ./src/areas/brand/actions/index.ts
var brandLinkClick = function(brand) {
    return {
        type: "BRAND_LINK_CLICK",
        brand: brand
    };
};
var brandMediaToggle = function(show) {
    return {
        type: "BRAND_MEDIA_TOGGLE",
        show: show
    };
};
/* harmony default export */ const actions = ({
    brandLinkClick: brandLinkClick,
    brandMediaToggle: brandMediaToggle
});

// EXTERNAL MODULE: ./src/components/page/index.ts + 7 modules
var page = __webpack_require__(42575);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(87172);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/areas/brand/components/brand-category-card/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  height: 86px;\n  width: 86px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  line-height: 18px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  max-height: 30px;\n  width: 50px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 600;\n  line-height: 18px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  display: block;\n  min-width: ",
        ";\n  padding: ",
        ";\n  padding-top: ",
        ";\n  position: relative;\n  text-align: center;\n\n  :hover,\n  &.focus-visible {\n    background-color: ",
        ";\n    outline: none;\n  }\n\n  ",
        " {\n    position: absolute;\n    right: ",
        ";\n    top: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var baseMargin = 8;
var minCardWidth = 160;
var CategoryLogo = styled_components_browser_esm["default"].img.withConfig({
    displayName: "CategoryLogo",
    componentId: "sc-0-0"
})(_templateObject());
var BrandName = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BrandName",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall);
var BrandLogo = styled_components_browser_esm["default"].img.withConfig({
    displayName: "BrandLogo",
    componentId: "sc-0-2"
})(_templateObject2());
var CategoryName = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CategoryName",
    componentId: "sc-0-3"
})(_templateObject3());
var Card = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "Card",
    componentId: "sc-0-4"
})(_templateObject4(), function(props) {
    return props.theme.bg.secondary;
}, base/* layout.borderRadius */.bK.borderRadius, function(props) {
    return props.theme.text.primary;
}, (0,base/* remCalc */.vR)(minCardWidth), (0,base/* remCalc */.vR)(baseMargin * 2), (0,base/* remCalc */.vR)(baseMargin * 3), function(props) {
    return base/* colorUtils.shadeColor */.$n.shadeColor(props.theme.bg.secondary, -10);
}, BrandLogo, (0,base/* remCalc */.vR)(baseMargin * 2), (0,base/* remCalc */.vR)(baseMargin * 2));

;// CONCATENATED MODULE: ./src/areas/brand/components/brand-category-card/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var BrandCategoryCard = function(_param) /*#__PURE__*/ {
    var categoryImage = _param.categoryImage, categoryName = _param.categoryName, brandLogo = _param.brandLogo, brandName = _param.brandName, clickableProps = _objectWithoutProperties(_param, [
        "categoryImage",
        "categoryName",
        "brandLogo",
        "brandName"
    ]);
    return react.createElement(Card, _extends({}, clickableProps), /*#__PURE__*/ react.createElement(CategoryLogo, {
        src: categoryImage,
        alt: categoryName
    }), brandLogo && /*#__PURE__*/ react.createElement(BrandLogo, {
        src: brandLogo,
        alt: brandName
    }), /*#__PURE__*/ react.createElement(BrandName, null, brandName), /*#__PURE__*/ react.createElement(CategoryName, null, categoryName));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(39233);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(42779);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.1.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(51322);
;// CONCATENATED MODULE: ./src/areas/brand/components/category-tree-listing/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n    column-count: 3;\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  column-count: 2;\n  h3,\n  h4 {\n    font-size: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n    margin-bottom: ",
        "\n  "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n    padding: 0 10px;\n  "
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  break-inside: avoid;\n  margin-bottom: ",
        ";\n  ",
        ";\n\n  ",
        "\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n  &:hover {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var Block = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Block",
    componentId: "sc-0-0"
})(styles_templateObject1(), (0,base/* remCalc */.vR)(14), base/* media.mediumUp */.BC.mediumUp(styles_templateObject()));
var Category = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Category",
    componentId: "sc-0-1"
})(styles_templateObject4(), base/* layout.marginBottomSubComponent */.bK.marginBottomSubComponent, base/* media.mediumDown */.BC.mediumDown(styles_templateObject2(), (0,base/* remCalc */.vR)(base/* layout.marginBottomSubComponentVal */.bK.marginBottomSubComponentVal * 2 / 3)), base/* media.mediumUp */.BC.mediumUp(styles_templateObject3()));
var Link = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "Link",
    componentId: "sc-0-2"
})(_templateObject5(), function(p) {
    return p.theme.text.callToActionHover;
});

;// CONCATENATED MODULE: ./src/areas/brand/components/category-tree-listing/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var CategoryTreeListing = function(param) {
    var categoryTree = param.categoryTree, brand = param.brand;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), linkTo = ref.linkTo, t = ref.t;
    var linkToBrandCategory = function(category, brandId) {
        return linkTo("brandCategory", _objectSpreadProps(_objectSpread({}, category), {
            brandId: brandId
        }));
    };
    var renderHeaderContent = function(category, depth, linkToProductCollection) {
        return /*#__PURE__*/ react.createElement(react.Fragment, null, depth === 0 ? /*#__PURE__*/ react.createElement("h3", null, category.name) : /*#__PURE__*/ react.createElement("h4", null, category.name), !category.children && linkToProductCollection && /*#__PURE__*/ react.createElement(Link, {
            to: linkToProductCollection,
            onClick: function() {
                (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.BRAND_CATEGORY_TREE */.U.BRAND_CATEGORY_TREE,
                    nextPage: linkToProductCollection
                });
            }
        }, t("header", "mega-menu.show-all-in-category", {
            name: category.name
        })));
    };
    var renderTree = function(category) {
        var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        var ref;
        var toHeader = (category === null || category === void 0 ? void 0 : category.product_collection) ? linkToBrandCategory(category, brand.id) : null;
        return /*#__PURE__*/ react.createElement(Category, {
            key: category.id
        }, renderHeaderContent(category, depth, toHeader), category === null || category === void 0 ? void 0 : (ref = category.children) === null || ref === void 0 ? void 0 : ref.map(function(child) {
            var to = linkToBrandCategory(child, brand.id);
            return child.children || depth === 0 ? renderTree(child, depth + 1) : /*#__PURE__*/ react.createElement(Link, {
                to: to,
                key: child.id,
                onClick: function() {
                    return (0,tracking/* trackInternalNavigationClick */.p)({
                        scope: tracking/* InternalNavigationScope.BRAND_CATEGORY_TREE */.U.BRAND_CATEGORY_TREE,
                        nextPage: to
                    });
                }
            }, child.name);
        }));
    };
    return /*#__PURE__*/ react.createElement(Block, null, categoryTree.map(function(cat) {
        return cat ? renderTree(cat) : null;
    }));
};

// EXTERNAL MODULE: ./src/components/flexible-grid/index.ts + 2 modules
var flexible_grid = __webpack_require__(59857);
;// CONCATENATED MODULE: ./src/areas/brand/components/category-listing/styles.ts
function category_listing_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function category_listing_styles_templateObject() {
    var data = category_listing_styles_taggedTemplateLiteral([
        "\n    grid-template-columns: repeat(auto-fit, 1fr);\n\n    /* Hide the last element to get a more even number of grid items. */\n    & > :last-child {\n      display: none;\n    }\n  "
    ]);
    category_listing_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function category_listing_styles_templateObject1() {
    var data = category_listing_styles_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n\n  ",
        "\n"
    ]);
    category_listing_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function category_listing_styles_templateObject2() {
    var data = category_listing_styles_taggedTemplateLiteral([
        "\n  margin-top: 40px;\n"
    ]);
    category_listing_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var styles_baseMargin = 8;
var CategoryGrid = (0,styled_components_browser_esm["default"])(flexible_grid/* Grid */.r).attrs({
    gap: (0,base/* remCalc */.vR)(styles_baseMargin),
    columnCount: "auto-fit",
    columnMinWidth: (0,base/* remCalc */.vR)(minCardWidth)
}).withConfig({
    displayName: "CategoryGrid",
    componentId: "sc-0-0"
})(category_listing_styles_templateObject1(), (0,base/* remCalc */.vR)(styles_baseMargin * 2), base/* media.mediumDown */.BC.mediumDown(category_listing_styles_templateObject()));
var CategoryTree = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CategoryTree",
    componentId: "sc-0-1"
})(category_listing_styles_templateObject2());

;// CONCATENATED MODULE: ./src/areas/brand/components/category-listing/index.tsx
function category_listing_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function category_listing_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            category_listing_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function category_listing_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function category_listing_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        category_listing_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var CategoryListing = function(props) {
    var categories = props.categories, categoryTree = props.categoryTree, brand = props.brand;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, linkTo = ref.linkTo;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, null, t("brand", "popular-categories.title", {
        brand: brand.name
    })), /*#__PURE__*/ react.createElement(CategoryGrid, null, categories && categories.nodes && categories.nodes.map(function(category, index) {
        var to = linkTo("brandCategory", category_listing_objectSpreadProps(category_listing_objectSpread({}, category), {
            brandId: brand.id
        }));
        return category && /*#__PURE__*/ react.createElement(BrandCategoryCard, {
            key: category.id,
            categoryImage: category.logo,
            categoryName: category.name,
            brandLogo: brand.logo,
            brandName: brand.name,
            to: to,
            onClick: function() {
                return (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.BRAND_CATEGORY_CARD */.U.BRAND_CATEGORY_CARD,
                    nextPage: to,
                    index: index
                });
            }
        });
    }))), /*#__PURE__*/ react.createElement(CategoryTree, null, /*#__PURE__*/ react.createElement(CategoryTreeListing, {
        categoryTree: categoryTree,
        brand: brand
    })));
};
/* harmony default export */ const category_listing = (/*#__PURE__*/(0,react.memo)(CategoryListing));

// EXTERNAL MODULE: ./src/components/product-card-new/product-card-context.tsx
var product_card_context = __webpack_require__(52416);
// EXTERNAL MODULE: ./src/components/horizontal-scroll/variants/medium-card-horizontal-scroll.tsx
var medium_card_horizontal_scroll = __webpack_require__(89960);
// EXTERNAL MODULE: ./src/components/product-card-new/index.tsx + 24 modules
var product_card_new = __webpack_require__(75400);
;// CONCATENATED MODULE: ./src/areas/brand/components/product-listing/index.tsx







var ProductListing = function(param) {
    var products = param.products, brandName = param.brandName;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, null, t("brand", "popular-products.title", {
        brand: brandName
    })), /*#__PURE__*/ react.createElement(medium_card_horizontal_scroll/* MediumCardHorizontalScroll */._, {
        negativeMargin: true
    }, products && products.nodes && products.nodes.filter(Boolean).map(function(prod, index) {
        return /*#__PURE__*/ react.createElement(product_card_context/* ProductCardContextContainer */.h, {
            key: prod.id,
            onClick: function() {
                return (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.BRAND_PRODUCT_CARD */.U.BRAND_PRODUCT_CARD,
                    nextPage: prod.pathName,
                    index: index
                });
            },
            product: prod
        }, /*#__PURE__*/ react.createElement(product_card_new/* ProductGridCard */.r4, null));
    })));
};
/* harmony default export */ const product_listing = (ProductListing);

// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(33999);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/graph/index.js
var graph = __webpack_require__(24492);
;// CONCATENATED MODULE: ./src/areas/brand/components/styles.tsx
function components_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function components_styles_templateObject() {
    var data = components_styles_taggedTemplateLiteral([
        "\n    flex-direction: column;\n  "
    ]);
    components_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function components_styles_templateObject1() {
    var data = components_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  color: $text-color;\n  ",
        "\n"
    ]);
    components_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function components_styles_templateObject2() {
    var data = components_styles_taggedTemplateLiteral([
        "\n  height: 31px;\n  width: auto;\n  margin: 5px;\n"
    ]);
    components_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function components_styles_templateObject3() {
    var data = components_styles_taggedTemplateLiteral([
        "\n  padding: ",
        " 0;\n  svg {\n    fill: #fff;\n    margin-right: 5px;\n  }\n"
    ]);
    components_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function components_styles_templateObject4() {
    var data = components_styles_taggedTemplateLiteral([
        ""
    ]);
    components_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = components_styles_taggedTemplateLiteral([
        "\n  padding: 0 ",
        ";\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = components_styles_taggedTemplateLiteral([
        "\n  margin: ",
        " ",
        "\n    ",
        " 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}






var Header = (0,styled_components_browser_esm["default"])(page/* PageHeader */.mr).withConfig({
    displayName: "Header",
    componentId: "sc-0-0"
})(components_styles_templateObject1(), base/* media.smallOnly */.BC.smallOnly(components_styles_templateObject()));
var Image = styled_components_browser_esm["default"].img.withConfig({
    displayName: "Image",
    componentId: "sc-0-1"
})(components_styles_templateObject2());
var Analytics = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Analytics",
    componentId: "sc-0-2"
})(components_styles_templateObject3(), (0,base/* remCalc */.vR)(5));
var AnalyticsButton = (0,styled_components_browser_esm["default"])(components_button/* Button */.z).attrs({
    size: "small",
    color: "primary",
    icon: /*#__PURE__*/ react.createElement(graph/* IconGraph */.T, null)
}).withConfig({
    displayName: "AnalyticsButton",
    componentId: "sc-0-3"
})(components_styles_templateObject4());
var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-4"
})(styles_templateObject5(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var BreadCrumbWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BreadCrumbWrapper",
    componentId: "sc-0-5"
})(_templateObject6(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/brand/components/brand-content/index.tsx




var BrandContent = function(param) {
    var id = param.id, name = param.name, products = param.products, categories = param.categories, categoryTree = param.categoryTree, analyticsAccessLink = param.analyticsAccessLink;
    return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(Header, {
        title: name
    }, analyticsAccessLink && /*#__PURE__*/ react.createElement(Analytics, null, analyticsAccessLink)), /*#__PURE__*/ react.createElement(product_listing, {
        products: products,
        brandName: name
    }), /*#__PURE__*/ react.createElement(category_listing, {
        categories: categories,
        categoryTree: categoryTree,
        brand: {
            id: id,
            name: name
        }
    }));
};
/* harmony default export */ const brand_content = (BrandContent);

;// CONCATENATED MODULE: ./src/areas/brand/components/featured-brand-content/index.tsx




var FeaturedBrandContent = function(param) {
    var id = param.id, name = param.name, logo = param.logo, externalUri = param.externalUri, externalUriText = param.externalUriText, brandLinkClick = param.brandLinkClick, products = param.products, categories = param.categories, categoryTree = param.categoryTree, analyticsAccessLink = param.analyticsAccessLink;
    var brand = (0,react.useMemo)(function() {
        return {
            id: id,
            name: name,
            logo: logo
        };
    }, [
        id,
        name,
        logo
    ]);
    var titleLogo = (0,react.useMemo)(function() {
        return /*#__PURE__*/ react.createElement(Image, {
            width: 70,
            alt: name,
            src: logo
        });
    }, [
        name,
        logo
    ]);
    return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(Header, {
        titleLogo: titleLogo,
        title: name
    }, analyticsAccessLink && /*#__PURE__*/ react.createElement(Analytics, null, analyticsAccessLink), /*#__PURE__*/ react.createElement("a", {
        onClick: brandLinkClick,
        target: "_BLANK",
        rel: "nofollow noopener",
        href: externalUri || externalUriText
    }, externalUriText)), /*#__PURE__*/ react.createElement(product_listing, {
        products: products,
        brandName: name
    }), /*#__PURE__*/ react.createElement(category_listing, {
        categories: categories,
        categoryTree: categoryTree,
        brand: brand
    }));
};
/* harmony default export */ const featured_brand_content = (FeaturedBrandContent);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/list/variants.js
var variants = __webpack_require__(79514);
// EXTERNAL MODULE: ./src/ui/list-layouts/index.ts
var list_layouts = __webpack_require__(35883);
// EXTERNAL MODULE: ./src/components/product-image/index.tsx
var product_image = __webpack_require__(23354);
// EXTERNAL MODULE: ./src/components/product-row/index.tsx + 1 modules
var product_row = __webpack_require__(69919);
;// CONCATENATED MODULE: ./src/areas/brand/components/featured-products/styles.ts
function featured_products_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function featured_products_styles_templateObject() {
    var data = featured_products_styles_taggedTemplateLiteral([
        "\n  padding: 5px 10px;\n"
    ]);
    featured_products_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function featured_products_styles_templateObject1() {
    var data = featured_products_styles_taggedTemplateLiteral([
        "\n  align-items: start;\n  min-height: auto;\n"
    ]);
    featured_products_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var styles_Header = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Header",
    componentId: "sc-0-0"
})(featured_products_styles_templateObject());
var Product = (0,styled_components_browser_esm["default"])(product_row/* default */.Z).withConfig({
    displayName: "Product",
    componentId: "sc-0-1"
})(featured_products_styles_templateObject1());

;// CONCATENATED MODULE: ./src/areas/brand/components/featured-products/index.tsx



var FeaturedProducts = function(param) {
    var title = param.title, products = param.products;
    if (!products || products.length < 1) return null;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(styles_Header, null, title), products.filter(Boolean).map(function(param) {
        var id = param.id, name = param.name, pathName = param.pathName, media = param.media, priceSummary = param.priceSummary, subtitle = param.subtitle;
        return /*#__PURE__*/ react.createElement(Product, {
            key: id,
            link: pathName,
            name: name,
            image: media && /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
                name: name,
                src: media.first
            }),
            price: priceSummary.regular || priceSummary.alternative,
            subtitle: subtitle
        });
    }));
};
/* harmony default export */ const featured_products = (FeaturedProducts);

;// CONCATENATED MODULE: ./src/areas/brand/components/premium-banner/styles.ts
function premium_banner_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function premium_banner_styles_templateObject() {
    var data = premium_banner_styles_taggedTemplateLiteral([
        "\n  float: right;\n  position: relative;\n"
    ]);
    premium_banner_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function premium_banner_styles_templateObject1() {
    var data = premium_banner_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 0;\n  background-color: rgba(220, 220, 220, 0.8);\n  color: #666;\n  font-size: 11px;\n  padding: 0px 3px;\n"
    ]);
    premium_banner_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var styles_Block = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Block",
    componentId: "sc-0-0"
})(premium_banner_styles_templateObject());
var Label = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Label",
    componentId: "sc-0-1"
})(premium_banner_styles_templateObject1());

;// CONCATENATED MODULE: ./src/areas/brand/components/premium-banner/index.tsx


var PremiumBanner = function(param) {
    var label = param.label, brandName = param.brandName, banner = param.banner;
    return /*#__PURE__*/ react.createElement(styles_Block, null, /*#__PURE__*/ react.createElement(Label, null, label), banner && /*#__PURE__*/ react.createElement("img", {
        alt: brandName,
        src: banner
    }));
};
/* harmony default export */ const premium_banner = (PremiumBanner);

// EXTERNAL MODULE: ./src/components/carousel/index.ts + 6 modules
var carousel = __webpack_require__(60102);
// EXTERNAL MODULE: ./src/components/lightbox/index.tsx
var lightbox = __webpack_require__(97030);
;// CONCATENATED MODULE: ./src/areas/brand/components/video-listing/styles.ts
function video_listing_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function video_listing_styles_templateObject() {
    var data = video_listing_styles_taggedTemplateLiteral([
        "\n  display: flex;\n\n  cursor: pointer;\n  .pj-ui-carousel-video-thumbnail--play-icon svg {\n    width: 75px !important;\n    height: 75px !important;\n  }\n  .pj-ui-carousel-video-thumbnail {\n    width: inherit;\n  }\n"
    ]);
    video_listing_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function video_listing_styles_templateObject1() {
    var data = video_listing_styles_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    video_listing_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Button = styled_components_browser_esm["default"].button.withConfig({
    displayName: "Button",
    componentId: "sc-0-0"
})(video_listing_styles_templateObject());
var StyledPanel = (0,styled_components_browser_esm["default"])(panel/* Panel */.s_).withConfig({
    displayName: "StyledPanel",
    componentId: "sc-0-1"
})(video_listing_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

;// CONCATENATED MODULE: ./src/areas/brand/components/video-listing/index.tsx
/* eslint-disable react/prop-types */ function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}








var VideoListing = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    _inherits(VideoListing, _PureComponent);
    var _super = _createSuper(VideoListing);
    function VideoListing(props) {
        _classCallCheck(this, VideoListing);
        var _this;
        _this = _super.call(this, props);
        _this.close = function() {
            _this.props.brandMediaToggle(false);
            _this.setState({
                open: false
            });
        };
        _this.state = {
            open: false,
            position: 0
        };
        _this.close = _this.close.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = VideoListing.prototype;
    _proto.open = function open(atIndex) {
        this.props.brandMediaToggle(true);
        this.setState({
            open: true,
            position: atIndex
        });
    };
    _proto.render = function render() {
        var _this = this;
        var videos = this.props.videos;
        var t = this.context.t;
        if (!videos) {
            return null;
        }
        var thumbnails = videos.map(function(video) {
            return /*#__PURE__*/ react.createElement(carousel/* VideoThumbnail */.uC, {
                key: video.source_id,
                src: video.thumbnail
            });
        });
        var items = videos.map(function(video) {
            return /*#__PURE__*/ react.createElement(carousel/* Video */.nk, {
                src: video.embed_url,
                key: video.source_id
            }, /*#__PURE__*/ react.createElement("p", null, t("product", "video.brand-disclaimer")));
        });
        return /*#__PURE__*/ react.createElement(react.Fragment, null, this.state.open && /*#__PURE__*/ react.createElement(lightbox/* default */.Z, {
            items: items,
            thumbnails: thumbnails,
            position: this.state.position,
            close: this.close,
            isOpen: this.state.open
        }), /*#__PURE__*/ react.createElement(StyledPanel, null, /*#__PURE__*/ react.createElement(medium_card_horizontal_scroll/* MediumCardHorizontalScroll */._, null, videos.map(function(video, index) {
            return /*#__PURE__*/ react.createElement(Button, {
                className: "brand-page-video",
                type: "button",
                key: video.source_id,
                tabIndex: 0,
                onClick: function() {
                    _this.open(index);
                }
            }, thumbnails[index]);
        }))));
    };
    return VideoListing;
}(react.PureComponent);
VideoListing.contextType = app_context/* AppContext */.Il;
var VideoListingTest = (/* unused pure expression or super */ null && (VideoListing));
/* harmony default export */ const video_listing = ((0,es/* connect */.$j)(null, actions)(VideoListing));

;// CONCATENATED MODULE: ./src/areas/brand/components/premium-brand-content/styles.ts
function premium_brand_content_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function premium_brand_content_styles_templateObject() {
    var data = premium_brand_content_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    premium_brand_content_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var premium_brand_content_styles_Header = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Header",
    componentId: "sc-0-0"
})(premium_brand_content_styles_templateObject());

;// CONCATENATED MODULE: ./src/areas/brand/components/premium-brand-content/index.tsx












var PremiumBrandContent = function(param) {
    var id = param.id, name = param.name, logo = param.logo, externalUri = param.externalUri, externalUriText = param.externalUriText, brandLinkClick = param.brandLinkClick, products = param.products, categories = param.categories, categoryTree = param.categoryTree, header = param.header, description = param.description, featuredProducts = param.featuredProducts, media = param.media, analyticsAccessLink = param.analyticsAccessLink;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var brand = (0,react.useMemo)(function() {
        return {
            id: id,
            name: name,
            logo: logo
        };
    }, [
        id,
        name,
        logo
    ]);
    var titleLogo = (0,react.useMemo)(function() {
        return logo ? /*#__PURE__*/ react.createElement(Image, {
            width: 70,
            alt: name,
            src: logo
        }) : null;
    }, [
        name,
        logo
    ]);
    var rawDescription = (0,react.useMemo)(function() {
        return {
            __html: description
        };
    }, [
        description
    ]);
    return /*#__PURE__*/ react.createElement(premium_brand_content_styles_Header, null, /*#__PURE__*/ react.createElement(premium_banner, {
        brandName: name,
        banner: header,
        label: t("brand", "premium-brand.information-notice", {
            brand: name
        })
    }), /*#__PURE__*/ react.createElement(list_layouts/* ColumnWithGutter */.U, null, /*#__PURE__*/ react.createElement(variants/* Row */.X2, null, /*#__PURE__*/ react.createElement(Header, {
        titleLogo: titleLogo,
        title: name
    }, analyticsAccessLink && /*#__PURE__*/ react.createElement(Analytics, null, analyticsAccessLink), /*#__PURE__*/ react.createElement("a", {
        onClick: brandLinkClick,
        target: "_BLANK",
        rel: "nofollow noopener",
        href: externalUri || externalUriText
    }, externalUriText))), /*#__PURE__*/ react.createElement(list_layouts/* ListMobileColumnElseRow */.N, {
        equallySizedChildren: true,
        gap: 1
    }, /*#__PURE__*/ react.createElement(variants/* Column */.sg, null, /*#__PURE__*/ react.createElement(featured_products, {
        title: t("brand", "premium-brand.featured-products"),
        products: featuredProducts
    })), /*#__PURE__*/ react.createElement("div", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: rawDescription
    }))), /*#__PURE__*/ react.createElement(video_listing, {
        videos: media.videos
    }), /*#__PURE__*/ react.createElement(product_listing, {
        products: products,
        brandName: name
    }), /*#__PURE__*/ react.createElement(category_listing, {
        categories: categories,
        categoryTree: categoryTree,
        brand: brand
    }));
};
/* harmony default export */ const premium_brand_content = ((0,es/* connect */.$j)(function(state) {
    return state;
})(/*#__PURE__*/ (0,react.memo)(PremiumBrandContent)));

// EXTERNAL MODULE: ./src/areas/brand/query.graphql
var query_graphql = __webpack_require__(80461);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
// EXTERNAL MODULE: ./src/hooks/use-page-query.ts
var use_page_query = __webpack_require__(72518);
;// CONCATENATED MODULE: ./src/areas/brand/queries/useBrandPage.ts


function useBrandPageQuery(variables) {
    return (0,use_page_query/* usePageQuery */.v)({
        query: (query_graphql_default()),
        routeName: "brand",
        variables: variables
    });
}

// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(56743);
// EXTERNAL MODULE: ./src/hooks/use-matched-route.ts
var use_matched_route = __webpack_require__(76493);
;// CONCATENATED MODULE: ./src/areas/brand/components/index.tsx
















var BrandPageLoader = function() {
    var ref, ref1;
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var ref2;
    var variables = {
        id: (ref2 = route === null || route === void 0 ? void 0 : (ref = route.match) === null || ref === void 0 ? void 0 : (ref1 = ref.params) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref2 !== void 0 ? ref2 : ""
    };
    var ref3 = useBrandPageQuery(variables), data = ref3.data, isLoading = ref3.isLoading, isSuccess = ref3.isSuccess;
    if (!isLoading && !isSuccess) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, {
        withAds: true,
        "data-test": "BrandPage"
    }, isLoading ? /*#__PURE__*/ react.createElement(loader/* default */.Z, null) : null, isSuccess && data.brand ? /*#__PURE__*/ react.createElement(BrandPage, {
        brand: data.brand
    }) : null);
};
var BrandPage = function(param) {
    var brand = param.brand;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var dispatch = (0,es/* useDispatch */.I0)();
    var brandLinkClick = actions.brandLinkClick;
    var id = brand.id, name = brand.name, featured = brand.featured, featuredProducts = brand.featuredProducts, premium = brand.premium, logo = brand.logo, products = brand.products, categories = brand.categories, categoryTree = brand.categoryTree, externalUri = brand.externalUri, externalUriText = brand.externalUriText, header = brand.header, description = brand.description, media = brand.media;
    var analyticsAccess = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1, ref2;
        return (ref = state.areas.account.me) === null || ref === void 0 ? void 0 : (ref1 = ref.analyticsAccess) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.brands) === null || ref2 === void 0 ? void 0 : ref2.find(function(item) {
            return (item === null || item === void 0 ? void 0 : item.id) === id;
        });
    });
    var analyticsAccessLink = analyticsAccess && /*#__PURE__*/ react.createElement(AnalyticsButton, {
        href: analyticsAccess.url
    }, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "account"
    }, "menu.pricespy-brand-analytics"));
    var brandLinkClickCallback = function() {
        return dispatch(brandLinkClick({
            id: Number(id),
            name: name,
            featured: featured
        }));
    };
    var content;
    if (premium) {
        content = /*#__PURE__*/ react.createElement(premium_brand_content, {
            id: Number(id),
            name: name,
            logo: logo,
            externalUri: externalUri,
            externalUriText: externalUriText,
            brandLinkClick: brandLinkClickCallback,
            products: products,
            categories: categories,
            categoryTree: categoryTree,
            header: header,
            description: description,
            featuredProducts: featuredProducts,
            media: media,
            analyticsAccessLink: analyticsAccessLink
        });
    } else if (featured) {
        content = /*#__PURE__*/ react.createElement(featured_brand_content, {
            id: Number(id),
            name: name,
            logo: logo,
            externalUri: externalUri,
            externalUriText: externalUriText,
            brandLinkClick: brandLinkClickCallback,
            products: products,
            categories: categories,
            categoryTree: categoryTree,
            analyticsAccessLink: analyticsAccessLink
        });
    } else {
        content = /*#__PURE__*/ react.createElement(brand_content, {
            id: Number(id),
            name: name,
            logo: logo,
            externalUri: externalUri,
            externalUriText: externalUriText,
            brandLinkClick: brandLinkClickCallback,
            products: products,
            categories: categories,
            categoryTree: categoryTree,
            analyticsAccessLink: analyticsAccessLink
        });
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(BreadCrumbWrapper, null, /*#__PURE__*/ react.createElement(breadcrumbs/* Breadcrumbs */.O, {
        containerProps: {
            onClick: function(nextPage) {
                (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.BREADCRUMB */.U.BREADCRUMB,
                    nextPage: nextPage
                });
            }
        }
    }, /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: "/"
    }, t("common", "breadcrumb.home")), /*#__PURE__*/ react.createElement("span", null, name))), /*#__PURE__*/ react.createElement(Content, null, content));
};
/* harmony default export */ const components = (/*#__PURE__*/(0,react.memo)(BrandPageLoader));


/***/ }),

/***/ 60102:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lr": () => (/* reexport */ carousel),
  "nk": () => (/* reexport */ Video),
  "uC": () => (/* reexport */ VideoThumbnail)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/detect-it@4.0.1/node_modules/detect-it/dist/detect-it.esm.js
var detect_it_esm = __webpack_require__(45115);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-swipe@6.0.4/node_modules/react-swipe/lib/index.js
var lib = __webpack_require__(13708);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(81736);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/chevron-left/index.js
var chevron_left = __webpack_require__(21932);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./src/components/horizontal-scroll/index.tsx + 1 modules
var horizontal_scroll = __webpack_require__(86898);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/components/carousel/components/carousel/carousel-item.tsx

var CarouselItem = function(param) {
    var item = param.item, _inView = param.inView, inView = _inView === void 0 ? false : _inView, _onClick = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    onClick, onClick = _onClick === void 0 ? function() {} : _onClick;
    return /*#__PURE__*/ react.cloneElement(item, {
        onClick: onClick,
        "data-test": "CarouselItem",
        inview: inView ? 1 : 0
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(33999);
;// CONCATENATED MODULE: ./src/components/carousel/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 40%;\n  background: ",
        ";\n  z-index: 1;\n  opacity: 0;\n  transition: opacity 0.5s;\n  color: ",
        ";\n\n  && {\n    svg {\n      path {\n        fill: ",
        ";\n      }\n    }\n  }\n\n  &&:hover,\n  &&:focus {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin: auto;\n  position: relative;\n  outline: 0;\n\n  &:hover {\n    ",
        " {\n      opacity: 1;\n    }\n  }\n\n  &--current,\n  &--prev,\n  &--next {\n    display: flex;\n    flex: 0 0 100%;\n    justify-content: center;\n    align-items: center;\n\n    > * {\n      max-height: inherit;\n      max-width: 100%;\n      width: auto;\n    }\n\n    &-animate-left {\n      transform: translate3d(100%, 0, 0);\n    }\n\n    &-animate-right {\n      transform: translate3d(-100%, 0, 0);\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  > * {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    max-height: 100%;\n    max-width: 100%;\n    width: auto;\n    min-width: 1px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: center;\n  padding-top: 10px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: center;\n  display: flex;\n  padding-top: 25px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      border-color: ",
        ";\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  width: 80px;\n  display: inline-block;\n  margin: 3px;\n  border: 1px solid transparent;\n  ",
        "\n\n  img {\n    height: 80px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: ",
        ";\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  height: 10px;\n  width: 10px;\n  margin: 5px;\n  display: inline-block;\n  background-color: transparent;\n  border: 1px solid ",
        ";\n  border-radius: 50%;\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}


var SwitchButton = (0,styled_components_browser_esm["default"])(components_button/* Button */.z).withConfig({
    displayName: "SwitchButton",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.theme.buttons.panning.bg;
}, function(p) {
    return p.theme.buttons.panning.text;
}, function(p) {
    return p.theme.buttons.panning.text;
}, function(p) {
    return p.theme.buttons.panning.bgHover;
});
var CarouselWrapper = styled_components_browser_esm["default"].div.attrs({
    "data-test": "Carousel"
}).withConfig({
    displayName: "CarouselWrapper",
    componentId: "sc-0-1"
})(_templateObject1(), SwitchButton);
var CarouselSlide = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CarouselSlide",
    componentId: "sc-0-2"
})(_templateObject2());
var CarouselSlideContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CarouselSlideContainer",
    componentId: "sc-0-3"
})(_templateObject3());
var IndicatorWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "IndicatorWrapper",
    componentId: "sc-0-4"
})(_templateObject4());
var ThumbnailWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ThumbnailWrapper",
    componentId: "sc-0-5"
})(_templateObject5());
var Thumbnail = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Thumbnail",
    componentId: "sc-0-6"
})(_templateObject7(), function(p) {
    return p.selected && (0,styled_components_browser_esm.css)(_templateObject6(), p.theme.colors.base0);
});
var Indicator = styled_components_browser_esm["default"].button.withConfig({
    displayName: "Indicator",
    componentId: "sc-0-7"
})(_templateObject9(), function(p) {
    return p.theme.colors.base500;
}, function(p) {
    return p.selected && (0,styled_components_browser_esm.css)(_templateObject8(), p.theme.colors.base500);
});

;// CONCATENATED MODULE: ./src/components/carousel/components/carousel/carousel.js
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}











var SWIPE = "swipe";
var THUMBNAIL = "thumbnail";
var DOT = "dot";
var _Component;
var Carousel = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(Carousel, _superClass);
    var _super = _createSuper(Carousel);
    function Carousel(props) {
        _classCallCheck(this, Carousel);
        var _this;
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "reactSwipe", null);
        _defineProperty(_assertThisInitialized(_this), "disableOnChange", false);
        _this.state = {
            currentPosition: 0
        };
        return _this;
    }
    _createClass(Carousel, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.focus) {
                    this.carousel.focus();
                }
                if (this.props.position !== null) {
                    // eslint-disable-next-line react/no-did-mount-set-state
                    this.setState({
                        currentPosition: this.props.position
                    });
                }
            }
        },
        {
            key: "setPosition",
            value: function setPosition(newPosition, type) {
                var // React swipe needs it's own emitted position to work
                // correctly if it uses more slides behind the scenes
                ref;
                this.props.onChange(newPosition, type);
                // Use this flag to make sure we don't send
                // two onChange events when adjusting slide
                this.disableOnChange = true;
                (ref = this.reactSwipe) === null || ref === void 0 ? void 0 : ref.slide(newPosition);
                this.setState({
                    currentPosition: newPosition
                });
            }
        },
        {
            key: "handleOnClick",
            value: function handleOnClick(e) {
                if (this.indicatorWrapper) {
                    if (e.target === this.indicatorWrapper || this.indicatorWrapper.contains(e.target)) {
                        return;
                    }
                }
                this.props.onClick();
            }
        },
        {
            key: "handleKeyDown",
            value: function handleKeyDown(e) {
                var ENTER = 13, SPACE = 32, LEFT = 37, RIGHT = 39;
                switch(e.keyCode){
                    case SPACE:
                        // Prevent default scroll behavior when space is hit
                        e.preventDefault();
                        this.props.onClick();
                        break;
                    case ENTER:
                        this.props.onClick();
                        break;
                    case LEFT:
                        var ref;
                        (ref = this.reactSwipe) === null || ref === void 0 ? void 0 : ref.prev();
                        break;
                    case RIGHT:
                        var ref1;
                        (ref1 = this.reactSwipe) === null || ref1 === void 0 ? void 0 : ref1.next();
                        break;
                    default:
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var t = this.context.t;
                var _props = this.props, height = _props.height, fallback = _props.fallback, thumbnails = _props.thumbnails, showArrows = _props.showArrows, showIndicator = _props.showIndicator, transitionTime = _props.transitionTime, clickForNext = _props.clickForNext;
                // Dynamic content might be empty, use fallback
                if (!this.props.children) {
                    return /*#__PURE__*/ react.createElement(CarouselWrapper, {
                        className: "pj-ui-carousel"
                    }, fallback);
                }
                var children = react.Children.toArray(this.props.children).filter(function(child) {
                    return child;
                });
                var childCount = react.Children.count(children);
                var singleItem = childCount === 1;
                var showIndicators = !thumbnails && showIndicator && childCount > 1;
                var showThumbnails = thumbnails && childCount > 1;
                var reactSwipeStyles = Carousel.getSwipeStyles();
                reactSwipeStyles.wrapper = _objectSpreadProps(_objectSpread({}, reactSwipeStyles.wrapper), {
                    maxHeight: "100%"
                });
                return /*#__PURE__*/ react.createElement(CarouselWrapper, {
                    ref: function(div) {
                        _this.carousel = div;
                    },
                    role: "button",
                    tabIndex: 0,
                    className: "pj-ui-carousel",
                    onClick: function(e) {
                        return _this.handleOnClick(e);
                    },
                    onKeyDown: function(e) {
                        return _this.handleKeyDown(e);
                    },
                    style: {
                        minHeight: height
                    }
                }, showArrows && !singleItem && /*#__PURE__*/ react.createElement(SwitchButton, {
                    style: {
                        left: "3%"
                    },
                    size: "large",
                    variant: "icon",
                    color: "secondary",
                    icon: /*#__PURE__*/ react.createElement(chevron_left/* IconChevronLeft */.e, null),
                    ariaLabel: t("symbols", "symbol.show-prev"),
                    onClick: function() {
                        var ref;
                        return (ref = _this.reactSwipe) === null || ref === void 0 ? void 0 : ref.prev();
                    },
                    "data-test": "SwitchButton"
                }), !singleItem ? /*#__PURE__*/ react.createElement((lib_default()), {
                    ref: function(reactSwipe) {
                        _this.reactSwipe = reactSwipe;
                    },
                    key: childCount,
                    style: reactSwipeStyles,
                    swipeOptions: {
                        auto: 0,
                        startSlide: this.state.currentPosition,
                        speed: transitionTime,
                        disableScroll: false,
                        continuous: true,
                        callback: function(pos) {
                            _this.setState({
                                currentPosition: pos
                            });
                            if (!_this.disableOnChange) {
                                _this.props.onChange(pos, SWIPE);
                            }
                            _this.disableOnChange = false;
                        }
                    }
                }, react.Children.map(children, function(child, index) {
                    /*#__PURE__*/ return react.createElement(CarouselSlide, {
                        key: index,
                        className: "pj-ui-carousel--slide",
                        style: {
                            maxHeight: height
                        }
                    }, /*#__PURE__*/ react.createElement(CarouselItem, {
                        inView: index === _this.state.currentPosition,
                        item: child,
                        onClick: clickForNext ? function() {
                            var ref;
                            return (ref = _this.reactSwipe) === null || ref === void 0 ? void 0 : ref.next();
                        } : null
                    }));
                })) : this.props.children, showArrows && !singleItem && /*#__PURE__*/ react.createElement(SwitchButton, {
                    style: {
                        right: "3%"
                    },
                    size: "large",
                    variant: "icon",
                    color: "secondary",
                    icon: /*#__PURE__*/ react.createElement(chevron_right/* IconChevronRight */.V, null),
                    ariaLabel: t("symbols", "symbol.show-next"),
                    onClick: function() {
                        var ref;
                        return (ref = _this.reactSwipe) === null || ref === void 0 ? void 0 : ref.next();
                    },
                    "data-test": "SwitchButton"
                }), showThumbnails && /*#__PURE__*/ react.createElement(ThumbnailWrapper, {
                    className: "pj-ui-carousel--thumbnail-wrapper"
                }, /*#__PURE__*/ react.createElement(horizontal_scroll/* HorizontalScroll */.Z, {
                    loadingHeight: 80,
                    itemWidth: 90
                }, thumbnails.map(function(thumbnail, index) {
                    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events
                    /*#__PURE__*/ react.createElement(Thumbnail, {
                        key: thumbnail,
                        role: "button",
                        tabIndex: index,
                        onClick: function() {
                            return _this.setPosition(index, THUMBNAIL);
                        },
                        className: "pj-ui-carousel--thumbnail",
                        selected: index === _this.state.currentPosition
                    }, typeof thumbnail === "string" ? /*#__PURE__*/ react.createElement("img", {
                        src: thumbnail,
                        alt: ""
                    }) : thumbnail));
                }))), showIndicators && /*#__PURE__*/ react.createElement(IndicatorWrapper, {
                    ref: function(div) {
                        _this.indicatorWrapper = div;
                    },
                    className: "pj-ui-carousel--indicator-wrapper"
                }, children.map(function(_, index) {
                    return(// eslint-disable-next-line jsx-a11y/control-has-associated-label
                    /*#__PURE__*/ react.createElement(Indicator, {
                        key: index,
                        type: "button",
                        onClick: function() {
                            return _this.setPosition(index, DOT);
                        },
                        selected: index === _this.state.currentPosition,
                        className: "pj-ui-carousel--indicator"
                    }));
                })));
            }
        }
    ], [
        {
            key: "getSwipeStyles",
            value: function getSwipeStyles() {
                if (!(lib_default()).defaultProps.style.wrapper) {
                    throw new Error("ReactSwipe is missing defaultProps.style.wrapper");
                }
                return _objectSpreadProps(_objectSpread({}, (lib_default()).defaultProps.style), {
                    wrapper: _objectSpreadProps(_objectSpread({}, (lib_default()).defaultProps.style.wrapper), {
                        display: "flex"
                    })
                });
            }
        }
    ]);
    return Carousel;
}(_Component = react.Component);
_defineProperty(Carousel, "deriveStateFromProps", function(nextProps) {
    Carousel.setState({
        currentPosition: nextProps.position
    });
});
var node = (prop_types_default()).node, number = (prop_types_default()).number, func = (prop_types_default()).func, arrayOf = (prop_types_default()).arrayOf, bool = (prop_types_default()).bool, string = (prop_types_default()).string;
Carousel.propTypes = {
    height: string.isRequired,
    focus: bool,
    showArrows: bool,
    showIndicator: bool,
    position: number,
    children: node,
    fallback: node,
    thumbnails: arrayOf(node),
    onClick: func,
    onChange: func,
    transitionTime: number,
    clickForNext: bool
};
Carousel.defaultProps = {
    position: null,
    focus: false,
    showArrows: [
        "hybrid",
        "mouseOnly"
    ].includes(detect_it_esm/* deviceType */.vO),
    showIndicator: true,
    children: null,
    fallback: null,
    thumbnails: null,
    onClick: base/* noop */.ZT,
    onChange: base/* noop */.ZT,
    transitionTime: 300,
    clickForNext: false
};
Carousel.contextType = app_context/* AppContext */.Il;
/* harmony default export */ const carousel = (Carousel);

;// CONCATENATED MODULE: ./src/components/carousel/components/video/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.8;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  height: 100%;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n  flex: 1;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n    margin-bottom: 30px;\n    "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-size: small;\n  font-style: italic;\n  margin-bottom: 20px;\n  ",
        "\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var styles_Thumbnail = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Thumbnail",
    componentId: "sc-0-0"
})(styles_templateObject());
var PlayIconWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PlayIconWrapper",
    componentId: "sc-0-1"
})(styles_templateObject1());
var VideoWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VideoWrapper",
    componentId: "sc-0-2"
})(styles_templateObject2());
var VideoFrame = styled_components_browser_esm["default"].iframe.withConfig({
    displayName: "VideoFrame",
    componentId: "sc-0-3"
})(styles_templateObject3());
var VideoChildrenContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VideoChildrenContainer",
    componentId: "sc-0-4"
})(styles_templateObject5(), base/* media.mediumUp */.BC.mediumUp(styles_templateObject4()));

;// CONCATENATED MODULE: ./src/components/carousel/components/video/video.tsx


var Video = function(param) {
    var src = param.src, children = param.children, _hideWhenNotInView = param.hideWhenNotInView, hideWhenNotInView = _hideWhenNotInView === void 0 ? true : _hideWhenNotInView, _height = param.height, height = _height === void 0 ? "450px" : _height, _inview = param.inview, inview = _inview === void 0 ? 0 : _inview;
    if (inview === 0 && hideWhenNotInView) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(VideoWrapper, {
        className: "pj-ui-carousel-video",
        style: {
            height: height
        }
    }, /*#__PURE__*/ react.createElement(VideoFrame, {
        src: src,
        title: src
    }), /*#__PURE__*/ react.createElement(VideoChildrenContainer, {
        className: "pj-ui-carousel-video--children"
    }, children));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/youtube/index.js
var youtube = __webpack_require__(36376);
;// CONCATENATED MODULE: ./src/components/carousel/components/video/video-thumbnail.tsx



var VideoThumbnail = function(props) {
    return /*#__PURE__*/ react.createElement(styles_Thumbnail, {
        className: "pj-ui-carousel-video-thumbnail"
    }, /*#__PURE__*/ react.createElement(PlayIconWrapper, {
        className: "pj-ui-carousel-video-thumbnail--play-icon"
    }, /*#__PURE__*/ react.createElement(youtube/* IconYoutube */.z, null)), /*#__PURE__*/ react.createElement("img", {
        src: props.src,
        alt: ""
    }));
};

;// CONCATENATED MODULE: ./src/components/carousel/index.ts






/***/ }),

/***/ 59857:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": () => (/* reexport */ Grid)
});

// UNUSED EXPORTS: GridRow

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
;// CONCATENATED MODULE: ./src/components/flexible-grid/grid.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n        margin-bottom: ",
        ";\n        margin-right: ",
        ";\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  /* Basic fallback for IE11 */\n\n  display: flex;\n  flex-wrap: wrap;\n  display: grid;\n  grid-template-columns: ",
        ";\n  grid-gap: ",
        ";\n\n  > * {\n    /* grid-gap fallback for IE11 */\n    ",
        "\n\n    @supports (display: grid) {\n      margin-bottom: 0;\n      margin-right: 0;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

/* stylelint-disable declaration-block-no-duplicate-properties */ var Grid = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Grid",
    componentId: "sc-0-0"
})(_templateObject1(), function(props) {
    return props.columnTemplate || "repeat(".concat(props.columnCount || "auto-fill", ", minmax(").concat(props.columnMinWidth || "auto", ", ").concat(props.columnMaxWidth || "1fr", "))");
}, function(props) {
    return props.gap || "10px";
}, function(props) {
    return props.gap && (0,styled_components_browser_esm.css)(_templateObject(), props.gap, props.gap);
});

// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/flexible-grid/grid-row.js
function grid_row_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function grid_row_templateObject() {
    var data = grid_row_taggedTemplateLiteral([
        "\n  grid-column: 1 / -1;\n  grid-row-start: ",
        ";\n\n  /* Fallback for browsers without grid support */\n  flex: 1 0 100%;\n  order: 1;\n"
    ]);
    grid_row_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var GridRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "GridRow",
    componentId: "sc-0-0"
})(grid_row_templateObject(), function(props) {
    return props.row;
});
var number = (prop_types_default()).number, node = (prop_types_default()).node;
GridRow.propTypes = {
    children: node,
    row: number
};
GridRow.defaultProps = {
    children: undefined,
    row: 1
};

;// CONCATENATED MODULE: ./src/components/flexible-grid/index.ts





/***/ }),

/***/ 97030:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13923);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var LightBox = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "extra";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | extra */ 737).then(__webpack_require__.bind(__webpack_require__, 91650));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(91650);
        }
        return eval("require.resolve")("./lightbox");
    }
});
var LoadableLightBox = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LightBox, _extends({}, props));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LoadableLightBox);


/***/ }),

/***/ 69919:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ product_row)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/components/offer/price/price-label/index.tsx + 1 modules
var price_label = __webpack_require__(14596);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var components_rating = __webpack_require__(29258);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
// EXTERNAL MODULE: ./src/components/product-checkbox/index.tsx + 1 modules
var product_checkbox = __webpack_require__(55548);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.1.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(51322);
;// CONCATENATED MODULE: ./src/components/product-row/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n  position: relative;\n  padding: 5px 10px;\n  outline: none;\n\n  :hover::after,\n  :focus::after {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      border-bottom: 1px solid ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        " {\n        padding-left: ",
        "px;\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "::before {\n        ",
        "\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  line-height: 1.2em;\n  min-height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  ",
        "\n  ",
        "\n  ",
        "\n\n  .pj-ui-product-core-properties {\n    margin: 0;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 0 0 auto;\n  width: 40px;\n  height: 40px;\n  margin-right: 10px;\n  background: ",
        ";\n  border-radius: ",
        ";\n\n  .pj-ui-product-image {\n    display: block;\n    max-width: 40px;\n    max-height: 40px;\n    width: auto;\n    height: auto;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 100%;\n  margin-right: 3px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  :not(:last-child) {\n    margin-bottom: 1px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 12px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 5px;\n  max-height: 55px;\n  min-width: 21px;\n  flex: 0 1 55px;\n  margin-left: 10px;\n  text-align: center;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  margin-left: 10px;\n  white-space: nowrap;\n  text-align: right;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n  font-size: 12px;\n  color: ",
        ";\n  fill: ",
        ";\n  align-items: center;\n\n  svg {\n    height: 16px !important;\n    width: 16px !important;\n    margin-left: 2px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  left: ",
        ";\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n\n  ",
        ":hover & {\n    ",
        "\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}




var ProductLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "ProductLink",
    componentId: "sc-0-0"
})(_templateObject(), base/* styledUtils.overlay */.au.overlay());
var Row = styled_components_browser_esm["default"].div.attrs({
    "data-test": "ProductRow"
}).withConfig({
    displayName: "Row",
    componentId: "sc-0-1"
})(_templateObject4(), function(props) {
    return props.showDivider && (0,styled_components_browser_esm.css)(_templateObject1(), function(p) {
        return p.theme.lines.primary;
    });
}, function(props) {
    return props.selectable && (0,styled_components_browser_esm.css)(_templateObject2(), ProductLink, product_checkbox/* PRODUCT_CHECKBOX_SIZE */.mr + (0,base/* pixelCalc */.A)(base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
}, function(props) {
    return props.selected && (0,styled_components_browser_esm.css)(_templateObject3(), ProductLink, base/* styledUtils.overlay */.au.overlay(props.theme.bg.productCompareLight));
});
var ProductImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductImage",
    componentId: "sc-0-2"
})(_templateObject5(), function(p) {
    return p.theme.colors.base200;
}, base/* layout.borderRadius */.bK.borderRadius);
var BasicInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BasicInfo",
    componentId: "sc-0-3"
})(_templateObject6());
var ProductName = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductName",
    componentId: "sc-0-4"
})(_templateObject7());
var Subtitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-5"
})(_templateObject8(), function(p) {
    return p.theme.text.tertiary;
});
var CampaignBadge = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CampaignBadge",
    componentId: "sc-0-6"
})(_templateObject9());
var PriceLabelWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "PriceLabelWrapper",
    componentId: "sc-0-7"
})(_templateObject10());
var StoreCount = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StoreCount",
    componentId: "sc-0-8"
})(_templateObject11(), function(p) {
    return p.theme.text.tertiary;
}, function(p) {
    return p.theme.icons.tertiary;
});
var Gutter = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Gutter",
    componentId: "sc-0-9"
})(_templateObject12());
var SelectBox = (0,styled_components_browser_esm["default"])(product_checkbox/* ProductCheckbox */.WX).withConfig({
    displayName: "SelectBox",
    componentId: "sc-0-10"
})(_templateObject13(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, Row, product_checkbox/* productCheckboxHoverStyle */.lo);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/shopping-cart/index.js
var shopping_cart = __webpack_require__(31615);
;// CONCATENATED MODULE: ./src/components/product-row/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}





var ProductRow = function(param) {
    var onClick = param.onClick, linkAttributes = param.linkAttributes, _link = param.link, link = _link === void 0 ? "" : _link, image = param.image, name = param.name, rating = param.rating, subtitle = param.subtitle, campaignBadge = param.campaignBadge, ratingCount = param.ratingCount, _ratingCountTranslation = param.ratingCountTranslation, ratingCountTranslation = _ratingCountTranslation === void 0 ? {
        domain: "product",
        key: "product-card.n-ratings"
    } : _ratingCountTranslation, price = param.price, storesCount = param.storesCount, storesCountText = param.storesCountText, children = param.children, className = param.className, showDivider = param.showDivider, selectable = param.selectable, selected = param.selected, onSelect = param.onSelect, onDeselect = param.onDeselect;
    var onToggle = selected ? onDeselect : onSelect;
    var clickHandler = (0,react.useCallback)(function(e) {
        if (selectable) {
            e.preventDefault();
            onToggle === null || onToggle === void 0 ? void 0 : onToggle();
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }, [
        selectable,
        onToggle,
        onClick
    ]);
    return /*#__PURE__*/ react.createElement(Row, {
        className: className,
        showDivider: showDivider,
        selectable: selectable,
        selected: selected
    }, /*#__PURE__*/ react.createElement(ProductLink, _extends({
        onClick: clickHandler
    }, linkAttributes || {}, {
        to: link,
        "aria-label": name
    }), image && /*#__PURE__*/ react.createElement(ProductImage, null, image), /*#__PURE__*/ react.createElement(BasicInfo, null, /*#__PURE__*/ react.createElement(ProductName, null, name), rating ? /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        hide: rating === null,
        rate: rating,
        showRate: true,
        size: "small",
        count: ratingCount,
        countTranslation: ratingCountTranslation,
        showCounter: true
    }) : null, subtitle && /*#__PURE__*/ react.createElement(Subtitle, null, subtitle)), campaignBadge && /*#__PURE__*/ react.createElement(CampaignBadge, null, campaignBadge), price && /*#__PURE__*/ react.createElement(PriceLabelWrapper, null, /*#__PURE__*/ react.createElement(price_label/* PriceLabel */.l, {
        value: price
    }), storesCount !== null && /*#__PURE__*/ react.createElement(StoreCount, {
        title: storesCountText
    }, /*#__PURE__*/ react.createElement("span", null, storesCount), " ", /*#__PURE__*/ react.createElement(shopping_cart/* IconShoppingCart */.w, {
        color: "base500"
    })))), children && /*#__PURE__*/ react.createElement(Gutter, null, children), selectable && /*#__PURE__*/ react.createElement(SelectBox, {
        selected: selected,
        onSelect: onSelect,
        onDeselect: onDeselect,
        "aria-label": name
    }));
};
/* harmony default export */ const product_row = (ProductRow);


/***/ }),

/***/ 35883:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": () => (/* binding */ ListMobileColumnElseRow),
/* harmony export */   "U": () => (/* binding */ ColumnWithGutter)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10297);
/* harmony import */ var _prisjakt_ui_list__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33024);
/* harmony import */ var _prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79514);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33399);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      flex-direction: row;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  flex-direction: column;\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var ColumnWithGutter = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_2__/* .Column */ .sg).withConfig({
    displayName: "ColumnWithGutter",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var ListMobileColumnElseRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_list__WEBPACK_IMPORTED_MODULE_1__/* .List */ .a).withConfig({
    displayName: "ListMobileColumnElseRow",
    componentId: "sc-0-1"
})(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .media.mediumUp */ .BC.mediumUp(_templateObject1()));


/***/ }),

/***/ 54817:
/***/ (function(module) {

/*
 * Swipe 2.0.0
 * Brad Birdsall
 * https://github.com/thebird/Swipe
 * Copyright 2013-2015, MIT License
 *
 */

(function(root, factory) {
  if ( true && module.exports) {
    module.exports = factory();
  } else {
    root.Swipe = factory();
  }
})(this, function() {
  'use strict';

  return function Swipe(container, options) {
    // utilities
    var noop = function() {}; // simple no operation function
    var offloadFn = function(fn) {
      setTimeout(fn || noop, 0);
    }; // offload a functions execution

    // check browser capabilities
    var browser = {
      addEventListener: !!window.addEventListener,
      touch:
        'ontouchstart' in window ||
        (window.DocumentTouch && document instanceof window.DocumentTouch),
      transitions: (function(temp) {
        var props = [
          'transitionProperty',
          'WebkitTransition',
          'MozTransition',
          'OTransition',
          'msTransition'
        ];
        for (var i in props)
          if (temp.style[props[i]] !== undefined) return true;
        return false;
      })(document.createElement('swipe'))
    };

    // quit if no root element
    if (!container) return;
    var element = container.children[0];
    var slides, slidePos, width, length;
    options = options || {};
    var index = parseInt(options.startSlide, 10) || 0;
    var speed = options.speed || 300;
    var widthOfSiblingSlidePreview =
      parseInt(options.widthOfSiblingSlidePreview, 10) || 0;
    var continuous = (options.continuous =
      options.continuous !== undefined ? options.continuous : true);

    function setup() {
      // cache slides
      slides = element.children;
      length = slides.length;

      // set continuous to false if only one slide
      continuous = slides.length < 2 ? false : options.continuous;

      // create an array to store current positions of each slide
      slidePos = new Array(slides.length);

      // determine width of each slide
      width =
        Math.round(
          container.getBoundingClientRect().width || container.offsetWidth
        ) -
        widthOfSiblingSlidePreview * 2;

      element.style.width = slides.length * width + 'px';

      // stack elements
      var pos = slides.length;
      while (pos--) {
        var slide = slides[pos];

        slide.style.width = width + 'px';
        slide.setAttribute('data-index', pos);

        if (browser.transitions) {
          slide.style.left = pos * -width + widthOfSiblingSlidePreview + 'px';
          move(pos, index > pos ? -width : index < pos ? width : 0, 0);
        }
      }

      // reposition elements before and after index
      if (continuous && browser.transitions) {
        move(circle(index - 1), -width, 0);
        move(circle(index + 1), width, 0);
      }

      if (!browser.transitions)
        element.style.left = index * -width + widthOfSiblingSlidePreview + 'px';

      container.style.visibility = 'visible';
    }

    function prev() {
      if (continuous) slide(index - 1);
      else if (index) slide(index - 1);
    }

    function next() {
      if (continuous) slide(index + 1);
      else if (index < slides.length - 1) slide(index + 1);
    }

    function circle(index) {
      // a simple positive modulo using slides.length
      return (slides.length + (index % slides.length)) % slides.length;
    }

    function slide(to, slideSpeed) {
      // do nothing if already on requested slide
      if (index == to) return;

      if (browser.transitions) {
        var direction = Math.abs(index - to) / (index - to); // 1: backward, -1: forward

        // get the actual position of the slide
        if (continuous) {
          var natural_direction = direction;
          direction = -slidePos[circle(to)] / width;

          // if going forward but to < index, use to = slides.length + to
          // if going backward but to > index, use to = -slides.length + to
          if (direction !== natural_direction)
            to = -direction * slides.length + to;
        }

        var diff = Math.abs(index - to) - 1;

        // move all the slides between index and to in the right direction
        while (diff--)
          move(
            circle((to > index ? to : index) - diff - 1),
            width * direction,
            0
          );

        to = circle(to);

        move(index, width * direction, slideSpeed || speed);
        move(to, 0, slideSpeed || speed);

        if (continuous) move(circle(to - direction), -(width * direction), 0); // we need to get the next in place
      } else {
        to = circle(to);
        animate(index * -width, to * -width, slideSpeed || speed);
        //no fallback for a circular continuous if the browser does not accept transitions
      }

      index = to;
      offloadFn(options.callback && options.callback(index, slides[index]));
    }

    function move(index, dist, speed) {
      translate(index, dist, speed);
      slidePos[index] = dist;
    }

    function translate(index, dist, speed) {
      var slide = slides[index];
      var style = slide && slide.style;

      if (!style) return;

      style.webkitTransitionDuration = style.MozTransitionDuration = style.msTransitionDuration = style.OTransitionDuration = style.transitionDuration =
        speed + 'ms';

      style.webkitTransform = 'translate(' + dist + 'px,0)' + 'translateZ(0)';
      style.msTransform = style.MozTransform = style.OTransform =
        'translateX(' + dist + 'px)';
    }

    function animate(from, to, speed) {
      // if not an animation, just reposition
      if (!speed) {
        element.style.left = to + 'px';
        return;
      }

      var start = +new Date();

      var timer = setInterval(function() {
        var timeElap = +new Date() - start;

        if (timeElap > speed) {
          element.style.left = to + 'px';

          if (delay) begin();

          options.transitionEnd &&
            options.transitionEnd.call(event, index, slides[index]);

          clearInterval(timer);
          return;
        }

        element.style.left =
          (to - from) * (Math.floor((timeElap / speed) * 100) / 100) +
          from +
          'px';
      }, 4);
    }

    // setup auto slideshow
    var delay = options.auto || 0;
    var interval;

    function begin() {
      clearTimeout(interval);
      interval = setTimeout(next, delay);
    }

    function stop() {
      delay = 0;
      clearTimeout(interval);
    }

    // setup initial vars
    var start = {};
    var delta = {};
    var isScrolling;

    // setup event capturing
    var events = {
      handleEvent: function(event) {
        switch (event.type) {
          case 'touchstart':
            this.start(event);
            break;
          case 'touchmove':
            this.move(event);
            break;
          case 'touchend':
            offloadFn(this.end(event));
            break;
          case 'webkitTransitionEnd':
          case 'msTransitionEnd':
          case 'oTransitionEnd':
          case 'otransitionend':
          case 'transitionend':
            offloadFn(this.transitionEnd(event));
            break;
          case 'resize':
            offloadFn(setup);
            break;
        }

        if (options.stopPropagation) event.stopPropagation();
      },
      start: function(event) {
        var touches = event.touches[0];

        // measure start values
        start = {
          // get initial touch coords
          x: touches.pageX,
          y: touches.pageY,

          // store time to determine touch duration
          time: +new Date()
        };

        // used for testing first move event
        isScrolling = undefined;

        // reset delta and end measurements
        delta = {};

        // attach touchmove and touchend listeners
        element.addEventListener('touchmove', this, false);
        element.addEventListener('touchend', this, false);
      },
      move: function(event) {
        // ensure swiping with one touch and not pinching
        if (event.touches.length > 1 || (event.scale && event.scale !== 1))
          return;

        if (options.disableScroll) return;

        var touches = event.touches[0];

        // measure change in x and y
        delta = {
          x: touches.pageX - start.x,
          y: touches.pageY - start.y
        };

        // determine if scrolling test has run - one time test
        if (typeof isScrolling == 'undefined') {
          isScrolling = !!(
            isScrolling || Math.abs(delta.x) < Math.abs(delta.y)
          );
        }

        // if user is not trying to scroll vertically
        if (!isScrolling) {
          // prevent native scrolling
          event.preventDefault();

          // stop slideshow
          stop();

          // increase resistance if first or last slide
          if (continuous) {
            // we don't add resistance at the end

            translate(
              circle(index - 1),
              delta.x + slidePos[circle(index - 1)],
              0
            );
            translate(index, delta.x + slidePos[index], 0);
            translate(
              circle(index + 1),
              delta.x + slidePos[circle(index + 1)],
              0
            );
          } else {
            delta.x =
              delta.x /
              ((!index && delta.x > 0) || // if first slide and sliding left
              (index == slides.length - 1 && // or if last slide and sliding right
                delta.x < 0) // and if sliding at all
                ? Math.abs(delta.x) / width + 1 // determine resistance level
                : 1); // no resistance if false

            // translate 1:1
            translate(index - 1, delta.x + slidePos[index - 1], 0);
            translate(index, delta.x + slidePos[index], 0);
            translate(index + 1, delta.x + slidePos[index + 1], 0);
          }
          options.swiping && options.swiping(-delta.x / width);
        }
      },
      end: function(event) {
        // measure duration
        var duration = +new Date() - start.time;

        // determine if slide attempt triggers next/prev slide
        var isValidSlide =
          (Number(duration) < 250 && // if slide duration is less than 250ms
            Math.abs(delta.x) > 20) || // and if slide amt is greater than 20px
          Math.abs(delta.x) > width / 2; // or if slide amt is greater than half the width

        // determine if slide attempt is past start and end
        var isPastBounds =
          (!index && delta.x > 0) || // if first slide and slide amt is greater than 0
          (index == slides.length - 1 && delta.x < 0); // or if last slide and slide amt is less than 0

        if (continuous) isPastBounds = false;

        // determine direction of swipe (true:right, false:left)
        var direction = delta.x < 0;

        // if not scrolling vertically
        if (!isScrolling) {
          if (isValidSlide && !isPastBounds) {
            if (direction) {
              if (continuous) {
                // we need to get the next in this direction in place

                move(circle(index - 1), -width, 0);
                move(circle(index + 2), width, 0);
              } else {
                move(index - 1, -width, 0);
              }

              move(index, slidePos[index] - width, speed);
              move(
                circle(index + 1),
                slidePos[circle(index + 1)] - width,
                speed
              );
              index = circle(index + 1);
            } else {
              if (continuous) {
                // we need to get the next in this direction in place

                move(circle(index + 1), width, 0);
                move(circle(index - 2), -width, 0);
              } else {
                move(index + 1, width, 0);
              }

              move(index, slidePos[index] + width, speed);
              move(
                circle(index - 1),
                slidePos[circle(index - 1)] + width,
                speed
              );
              index = circle(index - 1);
            }

            options.callback && options.callback(index, slides[index]);
          } else {
            if (continuous) {
              move(circle(index - 1), -width, speed);
              move(index, 0, speed);
              move(circle(index + 1), width, speed);
            } else {
              move(index - 1, -width, speed);
              move(index, 0, speed);
              move(index + 1, width, speed);
            }
          }
        }

        // kill touchmove and touchend event listeners until touchstart called again
        element.removeEventListener('touchmove', events, false);
        element.removeEventListener('touchend', events, false);
        element.removeEventListener('touchforcechange', function() {}, false);
      },
      transitionEnd: function(event) {
        if (parseInt(event.target.getAttribute('data-index'), 10) == index) {
          if (delay) begin();

          options.transitionEnd &&
            options.transitionEnd.call(event, index, slides[index]);
        }
      }
    };

    // trigger setup
    setup();

    // start auto slideshow if applicable
    if (delay) begin();

    // add event listeners
    if (browser.addEventListener) {
      // set touchstart event on element
      if (browser.touch) {
        element.addEventListener('touchstart', events, false);
        element.addEventListener('touchforcechange', function() {}, false);
      }

      if (browser.transitions) {
        element.addEventListener('webkitTransitionEnd', events, false);
        element.addEventListener('msTransitionEnd', events, false);
        element.addEventListener('oTransitionEnd', events, false);
        element.addEventListener('otransitionend', events, false);
        element.addEventListener('transitionend', events, false);
      }

      // set resize event on window
      window.addEventListener('resize', events, false);
    } else {
      window.onresize = function() {
        setup();
      }; // to play nice with old IE
    }

    // expose the Swipe API
    return {
      setup: function() {
        setup();
      },
      slide: function(to, speed) {
        // cancel slideshow
        stop();

        slide(to, speed);
      },
      prev: function() {
        // cancel slideshow
        stop();

        prev();
      },
      next: function() {
        // cancel slideshow
        stop();

        next();
      },
      stop: function() {
        // cancel slideshow
        stop();
      },
      getPos: function() {
        // return current index position
        return index;
      },
      getNumSlides: function() {
        // return total number of slides
        return length;
      },
      kill: function() {
        // cancel slideshow
        stop();

        // reset element
        element.style.width = '';
        element.style.left = '';

        // reset slides
        var pos = slides.length;
        while (pos--) {
          var slide = slides[pos];
          slide.style.width = '';
          slide.style.left = '';

          if (browser.transitions) translate(pos, 0, 0);
        }

        // removed event listeners
        if (browser.addEventListener) {
          // remove current event listeners
          element.removeEventListener('touchstart', events, false);
          element.removeEventListener('webkitTransitionEnd', events, false);
          element.removeEventListener('msTransitionEnd', events, false);
          element.removeEventListener('oTransitionEnd', events, false);
          element.removeEventListener('otransitionend', events, false);
          element.removeEventListener('transitionend', events, false);
          window.removeEventListener('resize', events, false);
        } else {
          window.onresize = null;
        }
      }
    };
  };
});


/***/ })

}]);